var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"type":"error","icon":_vm.mdiAlertCircle}},[_vm._v(" Error 404: Seite nicht gefunden! ")]),_c('v-btn',{staticClass:"primary",attrs:{"link":"","to":"/","block":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(_vm.mdiChevronLeft)+" ")]),_vm._v(" Zurück zur Startseite ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }